import i18n from './core.js'

const loaded = new Set(['tr'])

/**
 * Seçilen dil için JSON paketlerini (gerekirse) dinamik import ile yükler.
 * @param {string} lang
 */
export async function ensureLocalesLoaded(lang) {
  const code = String(lang ?? 'tr')
    .split('-')[0]
    .toLowerCase()
  if (code === 'tr' || loaded.has(code)) return

  if (code === 'en') {
    const m = await import('./registerEn.js')
    m.registerEn(i18n)
    loaded.add('en')
    return
  }
  if (code === 'ru') {
    const m = await import('./registerRu.js')
    m.registerRu(i18n)
    loaded.add('ru')
    return
  }

  await ensureLocalesLoaded('en')
}

/** tr kullanıcılarında en/ru chunk’larını boşta önceden yükle (dil değişiminde gecikme azalır). */
export function scheduleWarmupLocales(activeCode) {
  const run = () => {
    if (activeCode !== 'en') void ensureLocalesLoaded('en')
    if (activeCode !== 'ru') void ensureLocalesLoaded('ru')
  }
  if (typeof window === 'undefined') return
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(run, { timeout: 4000 })
  } else {
    window.setTimeout(run, 2000)
  }
}
